export type CookieInventoryRowId =
  | "session"
  | "csrf"
  | "leetcode"
  | "consentRecord"
  | "locale"
  | "playgroundPath"
  | "analytics"
  | "materialIcons";

export const COOKIE_INVENTORY_ROW_IDS: CookieInventoryRowId[] = [
  "session",
  "csrf",
  "leetcode",
  "consentRecord",
  "locale",
  "playgroundPath",
  "analytics",
  "materialIcons",
];
